import { render, staticRenderFns } from "./EditSupportOrganizationPage.vue?vue&type=template&id=06572085&"
import script from "./EditSupportOrganizationPage.vue?vue&type=script&lang=js&"
export * from "./EditSupportOrganizationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports